"use client";
import { services } from "data/services";
import ServiceCard from "./ServiceCard";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";
import ServiceBundling from "./ServiceBundling";

const ServicesInteractive = () => {
  const heroStats = [
    { number: "5", label: "Core Services", icon: "Briefcase" },
    { number: "∞", label: "Possibilities", icon: "Star" },
    { number: "1", label: "Bold Vision", icon: "Building" },
    // { number: '24/7', label: 'Project Support', icon: 'Clock' }
  ];
  return (
    <div  className="min-h-screen bg-background">
      <section className="py-4 lg:py-6 bg-background">
        <div className="container mx-auto px-4">
          <>
            <div className="flex items-center space-x-2 bg-accent/10 backdrop-blur-sm border border-accent/30 rounded-full px-6 py-1 mt-18 mb-2 w-fit mx-auto">
              <span className="text-accent font-medium text-sm">
                Services That Transform
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[1.05] max-w-5xl mb-2 text-text-primary text-center mx-auto">
              Corporate <span className="text-red-600 ">Solutions</span>
            </h1>

            <p className="mx-auto max-w-3xl text-center text-lg md:text-2xl leading-relaxed md:leading-loose text-neutral-800 mb-4">
              Five core service areas engineered for maximum impact. <span className=" mt-2 font-semibold">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-yellow-500 to-amber-600">
                  Bold brands
                </span>{" "}
                get noticed.{" "}
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-yellow-500 to-amber-600">
                  Smart brands
                </span>{" "}
                get results.
              </span>
              <span className="block mt-2 text-neutral-700">
                We deliver both.
              </span>
            </p>

            <div className="grid grid-cols-3 gap-8 max-w-4xl mx-auto mb-12">
              {heroStats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="w-12 h-12 border border-border text-black backdrop-blur-sm shadow-subtle rounded-full flex items-center justify-center mx-auto mb-3">
                    <Icon name={stat.icon} size={24} strokeWidth={2} />
                  </div>
                  <div className="text-3xl font-bold text-red-600 mb-1">
                    {stat.number}
                  </div>
                  <div className="text-black text-xs sm:text-lg">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-8xl mx-auto">
            {services.map((service, index) => (
              <ServiceCard key={service.id} service={service} index={index} />
            ))}
          </div>
        </div>
      </section>

      {/* <ServiceComparison />
      <ROICalculator /> */}
      <ServiceBundling />
      {/* <ProcessPreview /> */}

      <section className="hidden sm:block max-w-7xl mx-auto rounded-2xl p-4 md:p-8 text-center border-t">
        <h3 className="text-4xl font-bold text-primary mb-6">
          Why Choose Our Corporate Solutions?
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            {
              icon: "Target",
              title: "Strategic Approach",
              text: "Every project begins with understanding your business objectives and brand positioning",
            },
            {
              icon: "Settings",
              title: "Technical Excellence",
              text: "Professional-grade tools and workflows ensure consistency and quality",
            },
            {
              icon: "Users",
              title: "Partnership Focus",
              text: "Long-term collaboration built on trust, alignment, and reliability",
            },
          ].map((item, i) => (
            <div
              key={i}
              className="space-y-4 shadow-subtle rounded-2xl p-6 md:p-8"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 shadow-subtle rounded-full flex items-center justify-center mx-auto">
                <Icon name={item.icon} size={28} color="red" strokeWidth={2} />
              </div>

              <h4 className="text-lg md:text-xl font-semibold text-primary">
                {item.title}
              </h4>

              <p className="text-sm sm:text-base text-text-secondary">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-8 lg:py-16 bg-gradient-to-br from-primary via-red-900 to-secondary">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl sm:text-5xl font-black text-white mb-2 sm:mb-4">
              Ready to Transform
              <br />
              <span className="text-yellow-400">Your Brand?</span>
            </h2>
            <p className="text-base sm:text-xl text-white/90 mb-4 sm:mb-4  max-w-2xl mx-auto">
              Book a strategy session and drive measurable results.
            </p>
            <button className="px-10 py-2 bg-white text-primary font-bold text-base sm:text-lg rounded-lg shadow-dramatic hover:-translate-y-1 transition-all inline-flex items-center space-x-3">
              <span>Book Strategy Session</span>
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 7l5 5m0 0l-5 5m5-5H6"
                />
              </svg>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesInteractive;
